import { RefreshCw } from 'lucide-react';
import { useNewVersionAvailable } from '@/hooks/useNewVersionAvailable';

/**
 * Avviso "nuova versione disponibile" per il gestionale.
 *
 * Non ricarica da solo: con un form aperto si perderebbe quello che si sta
 * scrivendo. Se ci sono modifiche non salvate, il ricaricamento passa comunque
 * dall'avviso del browser (useUnsavedChangesWarning).
 * Sta sopra anche ai modali (z-index più alto), perché è proprio mentre si
 * lavora in un form che conta sapere di avere una versione vecchia.
 */
export function NewVersionBanner() {
  const available = useNewVersionAvailable();
  if (!available) return null;

  return (
    <div
      role="status"
      className="fixed left-4 right-4 mx-auto max-w-md z-[10000]"
      style={{ top: 'calc(env(safe-area-inset-top) + 0.75rem)' }}
    >
      <div className="flex items-center gap-3 rounded-xl border border-teal-500/40 bg-slate-900/95 backdrop-blur px-4 py-3 shadow-2xl">
        <RefreshCw className="w-4 h-4 text-teal-400 shrink-0" />
        <p className="flex-1 text-sm text-slate-200">È disponibile una nuova versione del gestionale.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="shrink-0 rounded-lg bg-teal-600 hover:bg-teal-500 px-3 py-1.5 text-sm font-medium text-white transition-colors"
        >
          Ricarica
        </button>
      </div>
    </div>
  );
}
